import React, { useContext, useState, useEffect } from "react";
import AlertsContext from "../../Contexts/Alertas/AlertasContext";
import GastosContext from "../../Contexts/Gastos/gastosContext";
import AuthContext from "../../Contexts/Autenticacion/authContext";
import { GASTO_AVISO, GASTO_SIMPLE, GASTO_URGENTE } from "../../types";

const FormIngresarGasto = ({ target }) => {
  const { mostrarAlerta } = useContext(AlertsContext);
  const { autenticado, usuario } = useContext(AuthContext);
  const { gastoSeleccionado, agregarGasto, actualizarGasto } = useContext(
    GastosContext
  );

  const initialState = {
    amount: "",
    type: GASTO_SIMPLE,
    description: "",
  };

  const [dataGasto, setDataGasto] = useState(initialState);

  useEffect(() => {
    if (gastoSeleccionado) {
      setDataGasto({
        amount: gastoSeleccionado.amount,
        type: gastoSeleccionado.type,
        description: gastoSeleccionado.description,
      });
    }
  }, [gastoSeleccionado]);

  const onChangeDataGasto = (e) => {
    setDataGasto({ ...dataGasto, [e.target.name]: e.target.value });
  };

  const ingresarNuevoGasto = () => {
    if (autenticado) {
      const { amount, description } = dataGasto;

      if (
        amount === 0 ||
        amount <= 0 ||
        !description ||
        description === "" ||
        description.length >= 140
      ) {
        mostrarAlerta("Faltan datos", "warning");
        return;
      }
      dataGasto.creador = usuario._id;
      dataGasto.username = usuario.username;

      agregarGasto(dataGasto);
      setDataGasto(initialState);
    } else {
      mostrarAlerta("Faltan campos", "error");
    }
  };
  const editarGasto = () => {
    const { amount, type, description } = dataGasto;
    if (
      amount === 0 ||
      amount <= 0 ||
      !description ||
      description === "" ||
      description.length >= 140
    ) {
      mostrarAlerta("Faltan datos", "warning");
      return;
    }
    const nuevoGasto = {
      amount,
      type,
      description,
      _id: gastoSeleccionado._id,
      creador: gastoSeleccionado._id,
      username: gastoSeleccionado.username,
    };

    actualizarGasto(nuevoGasto);
    setDataGasto(initialState);
  };

  return (
    <div className="card sticky-top mt-5 bg-secondary text-white shadow-lg pr-0 mr-0">
      <h5 className="card-header text-center">Ingresar Gasto</h5>
      <div className="card-body">
        <div className="py-4">
          <div className="input-group ">
            <div className="input-group-prepend">
              <span className="input-group-text">$</span>
            </div>
            <input
              type="number"
              className="form-control"
              name="amount"
              value={dataGasto.amount}
              aria-label="Dollar amount (with dot and two decimal places)"
              onChange={onChangeDataGasto}
            />
          </div>
          <div className="input-group justify-content-center">
            <label class="my-1 mr-2 p-1 " for="descripcion ">
              Descripcion
            </label>
            <input
              name="description"
              type="text"
              value={dataGasto.description}
              className="w-100"
              onChange={onChangeDataGasto}
              id="descripcion"
            />
          </div>
          <div className="input-group d-flex align-items-center m-2 justify-content-center">
            <label
              class="my-1 mr-2 text-center p-1 "
              for="inlineFormCustomSelectPref"
            >
              Tipo
            </label>
            <select
              class="custom-select my-1 mr-sm-2 w-100 rounded"
              id="inlineFormCustomSelectPref"
              name="type"
              value={dataGasto.type}
              onChange={onChangeDataGasto}
            >
              <option selected value={GASTO_SIMPLE}>
                Gasto simple
              </option>
              <option value={GASTO_URGENTE}>Urgente</option>
              <option value={GASTO_AVISO}>Aviso</option>
            </select>
          </div>
        </div>
        {gastoSeleccionado ? (
          <button
            className="btn btn-outline-light btn-block"
            onClick={editarGasto}
            data-toggle="modal"
            data-target={`#${target}`}
          >
            Editar
          </button>
        ) : (
          <button
            className="btn btn-outline-light btn-block"
            data-toggle="modal"
            data-target={`#${target}`}
            onClick={ingresarNuevoGasto}
          >
            Gastar
          </button>
        )}
      </div>
    </div>
  );
};

export default FormIngresarGasto;
